export default "__VITE_ASSET__BzQGuetJ__"